import YouTube from "react-youtube";
import styles from "../blog.module.scss";

const Youtube = ( { id, className = "" } ) => {

    return <YouTube videoId={id}  className={styles.youtube + " h-100 w-100 " + className} />

};

export default Youtube;